import VideoEmbed from "./project-details/VideoEmbed";
import ProjectInfo from "./project-details/ProjectInfo";
import ProjectDescription from "./project-details/ProjectDescription";
import Header from "./Header";
import Footer from "./Footer";

const Lia = () => {
  const projectData = {
    videoId: "g-wLu8LjKQM",
    stack: "HTML, Css, JavaScript",
    projectUrl: "https://lia-sa.com/",
    descriptionKey: "liaDesc",
  };
  return (
    <>
      <Header />
      <main id="main">
        <section className="portfolio-details">
          <div className="container">
            <div className="row gy-4">
              <VideoEmbed videoId={projectData.videoId} />

              <div className="col-lg-4">
                <ProjectInfo
                  stack={projectData.stack}
                  projectUrl={projectData.projectUrl}
                />
                <ProjectDescription
                  descriptionKey={projectData.descriptionKey}
                />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Lia;
